<app-spinner-overlay></app-spinner-overlay>

<div class="titolo-pagina" style="padding-top: 10px">
  <app-titolo-subtitolo
    titolo="Tema"
    subTitolo="Potrai successivamente cambiarla in base alle tue esigenze."
  ></app-titolo-subtitolo>
</div>

<div mat-dialog-content class="dialog-center-cont">
  <ng-scrollbar>
    @if (esrsFormGroup) {
      <form
        [formGroup]="esrsFormGroup"
        appFormContainer
        [larghezza]="6"
        style="padding-right: 20px"
      >
        <!------------------------- TEMA -------------------------------->

        <mat-form-field
          (mousedown)="$event.stopPropagation()"
          appFormElement
          [larghezza]="2"
          [riempi]="true"
          style="height: 100%"
        >
          <mat-label>Nome Breve</mat-label>
          <textarea
            #inputCodice
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            placeholder="Nome Breve"
            formControlName="nomeBreve"
            rows="1"
          ></textarea>
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field
          (mousedown)="$event.stopPropagation()"
          appFormElement
          [larghezza]="4"
          [riempi]="true"
          style="height: 100%"
        >
          <mat-label>Descrizione</mat-label>
          <textarea
            #inputDesc
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            placeholder="Descrizione"
            formControlName="descrizione"
            rows="1"
          ></textarea>
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <!-- IMPATTI -->
        <mat-accordion appFormElement [larghezza]="6">
          <div
            cdkDropList
            (cdkDropListDropped)="dropElementi($event, $any(esrsFormGroup.controls['impatti']))"
          >
            @for (impatti of $any(esrsFormGroup.controls['impatti']).controls; track $index) {
              <mat-expansion-panel
                (opened)="(false)"
                [expanded]="false"
                [disabled]="true"
                cdkDrag
                hideToggle
                class="impatti-mat-expansion-panel"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <button mat-icon-button title="Sposta" aria-label="Sposta">
                      <mat-icon class="drag-icon-impatti"> drag_handle </mat-icon>
                    </button>
                    <div class="cnt-titolo-descrizione-impatto">
                      <div style="color: black">Impatto</div>
                      <div class="testo-risposta">
                        {{ impatti?.value?.titolo }}
                      </div>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description class="impatti-mat-panel-description">
                    <button
                      mat-icon-button
                      title="Elimina Sottorisposta"
                      aria-label="Elimina Sottorisposta"
                      color="warn"
                      (click)="eliminaElemento($any(esrsFormGroup.controls['impatti']), $index)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </mat-panel-description>
                </mat-expansion-panel-header>
              </mat-expansion-panel>
            }
          </div>
        </mat-accordion>

        <div appFormElement [larghezza]="6" [riempi]="true">
          <button
            mat-stroked-button
            (click)="apriSelezioneImpatti($any(esrsFormGroup.controls['impatti']))"
            class="bottoni-risposte"
          >
            + Aggiungi Impatti Tema
          </button>
        </div>

        <!------------------------- SOTTO TEMA -------------------------------->
        <app-separatore-label
          appFormElement
          [larghezza]="6"
          [riempi]="true"
          titoloSeparatore="SottoTemi"
          style="margin: 15px 0px"
          [styleSeparatore]="'medium'"
        ></app-separatore-label>

        <div style="flex: 1; display: flex; flex-direction: column; row-gap: 10px">
          <ng-container formArrayName="sottoTemi">
            <mat-accordion class="accordion-sotto-tema">
              <div
                cdkDropList
                (cdkDropListDropped)="
                  dropElementi($event, $any(esrsFormGroup.controls['sottoTemi']))
                "
              >
                @for (
                  sottoTemi of $any(esrsFormGroup.controls['sottoTemi']).controls;
                  track $index
                ) {
                  <mat-expansion-panel cdkDrag style="background-color: #0060800d !important">
                    <mat-expansion-panel-header style="background-color: white">
                      <mat-panel-title>
                        <button mat-icon-button title="Sposta" aria-label="Sposta">
                          <mat-icon> drag_handle </mat-icon>
                        </button>

                        @if (sottoTemi.get('nomeBreve')?.value) {
                          {{ sottoTemi.get('nomeBreve')?.value }}
                        } @else {
                          <div class="testo-risposta">Inizia a configurare un sotto tema...</div>
                        }
                      </mat-panel-title>
                      <mat-panel-description>
                        <div class="legenda-panel">
                          <div>
                            Impatti: {{ $any(sottoTemi.controls['impatti']).controls.length }}
                          </div>
                          <div>
                            Sotto-SottoTemi:
                            {{ $any(sottoTemi.controls['sottoTemi']).controls.length }}
                          </div>
                        </div>
                        <button
                          mat-icon-button
                          title="Elimina Sottorisposta"
                          aria-label="Elimina Sottorisposta"
                          color="warn"
                          (click)="
                            eliminaElemento($any(esrsFormGroup.controls['sottoTemi']), $index)
                          "
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <ng-container [formGroup]="sottoTemi">
                      <div class="campi-tema campi-sotto-tema">
                        <mat-form-field
                          (mousedown)="$event.stopPropagation()"
                          appFormElement
                          [larghezza]="2"
                          [riempi]="true"
                          style="height: 100%"
                        >
                          <mat-label>Nome Breve</mat-label>
                          <textarea
                            #inputCodice
                            matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            placeholder="Nome Breve"
                            formControlName="nomeBreve"
                            rows="1"
                          ></textarea>
                          <mat-error appFormError></mat-error>
                        </mat-form-field>

                        <mat-form-field
                          (mousedown)="$event.stopPropagation()"
                          appFormElement
                          [larghezza]="4"
                          [riempi]="true"
                          style="height: 100%"
                        >
                          <mat-label>Descrizione</mat-label>
                          <textarea
                            #inputDesc
                            matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            placeholder="Descrizione"
                            formControlName="descrizione"
                            rows="1"
                          ></textarea>
                          <mat-error appFormError></mat-error>
                        </mat-form-field>
                      </div>

                      <!-- IMPATTI -->
                      <mat-accordion appFormElement [larghezza]="6">
                        <div
                          cdkDropList
                          (cdkDropListDropped)="
                            dropElementi($event, $any(sottoTemi.controls['impatti']))
                          "
                        >
                          @for (
                            impatti of $any(sottoTemi.controls['impatti']).controls;
                            track $index
                          ) {
                            <mat-expansion-panel
                              (opened)="(false)"
                              [expanded]="false"
                              [disabled]="true"
                              cdkDrag
                              hideToggle
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                  <button mat-icon-button title="Sposta" aria-label="Sposta">
                                    <mat-icon class="drag-icon-impatti"> drag_handle </mat-icon>
                                  </button>
                                  <div class="cnt-titolo-descrizione-impatto">
                                    <div style="color: black">Impatto</div>
                                    <div class="testo-risposta">
                                      {{ impatti?.value?.titolo }}
                                    </div>
                                  </div>
                                </mat-panel-title>
                                <mat-panel-description class="impatti-mat-panel-description">
                                  <button
                                    mat-icon-button
                                    title="Elimina Sottorisposta"
                                    aria-label="Elimina Sottorisposta"
                                    color="warn"
                                    (click)="eliminaElemento(sottoTemi.controls['impatti'], $index)"
                                  >
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </mat-panel-description>
                              </mat-expansion-panel-header>
                            </mat-expansion-panel>
                          }
                        </div>
                      </mat-accordion>

                      <div appFormElement [larghezza]="6" [riempi]="true">
                        <button
                          mat-stroked-button
                          (click)="apriSelezioneImpatti(sottoTemi.controls['impatti'])"
                          class="bottoni-risposte"
                        >
                          + Aggiungi Impatti Sotto-Tema
                        </button>
                      </div>

                      <!------------------------- SOTTO - SOTTO TEMA -------------------------------->

                      <div style="height: 15px"></div>
                      <app-separatore-label
                        appFormElement
                        [larghezza]="6"
                        [riempi]="true"
                        titoloSeparatore="Sotto-SottoTemi"
                        [styleSeparatore]="'small'"
                      ></app-separatore-label>
                      <div style="height: 15px"></div>

                      <ng-container formArrayName="sottoTemi">
                        <mat-accordion class="exp-sotto-sotto-tema">
                          <div
                            cdkDropList
                            (cdkDropListDropped)="
                              dropElementi($event, $any(sottoTemi.controls['sottoTemi']))
                            "
                          >
                            @for (
                              sottoSottoTemi of $any(sottoTemi.controls['sottoTemi']).controls;
                              track $index
                            ) {
                              <mat-expansion-panel cdkDrag>
                                <mat-expansion-panel-header>
                                  <mat-panel-title>
                                    <button mat-icon-button title="Sposta" aria-label="Sposta">
                                      <mat-icon> drag_handle </mat-icon>
                                    </button>

                                    @if (sottoSottoTemi.get('nomeBreve')?.value) {
                                      {{ sottoSottoTemi.get('nomeBreve')?.value }}
                                    } @else {
                                      <div class="testo-risposta">
                                        Inizia a configurare un sotto-sotto tema...
                                      </div>
                                    }
                                  </mat-panel-title>
                                  <mat-panel-description>
                                    <div class="legenda-panel">
                                      <div>
                                        Impatti:
                                        {{
                                          $any(sottoSottoTemi.controls['impatti']).controls.length
                                        }}
                                      </div>
                                    </div>
                                    <button
                                      mat-icon-button
                                      title="Elimina Sottorisposta"
                                      aria-label="Elimina Sottorisposta"
                                      color="warn"
                                      (click)="
                                        eliminaElemento(
                                          $any(sottoTemi.controls['sottoTemi']),
                                          $index
                                        )
                                      "
                                    >
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  </mat-panel-description>
                                </mat-expansion-panel-header>

                                <ngcontainer [formGroup]="sottoSottoTemi">
                                  <div class="campi-tema campi-sotto-tema">
                                    <mat-form-field
                                      (mousedown)="$event.stopPropagation()"
                                      appFormElement
                                      [larghezza]="2"
                                      [riempi]="true"
                                      style="height: 100%"
                                    >
                                      <mat-label>Nome Breve</mat-label>
                                      <textarea
                                        #inputCodice
                                        matInput
                                        cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="1"
                                        placeholder="Nome Breve"
                                        formControlName="nomeBreve"
                                        rows="1"
                                      ></textarea>
                                      <mat-error appFormError></mat-error>
                                    </mat-form-field>

                                    <mat-form-field
                                      (mousedown)="$event.stopPropagation()"
                                      appFormElement
                                      [larghezza]="4"
                                      [riempi]="true"
                                      style="height: 100%"
                                    >
                                      <mat-label>Descrizione</mat-label>
                                      <textarea
                                        #inputDesc
                                        matInput
                                        cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="1"
                                        placeholder="Descrizione"
                                        formControlName="descrizione"
                                        rows="1"
                                      ></textarea>
                                      <mat-error appFormError></mat-error>
                                    </mat-form-field>
                                  </div>

                                  <!-- IMPATTI -->
                                  <mat-accordion appFormElement [larghezza]="6">
                                    <div
                                      cdkDropList
                                      (cdkDropListDropped)="
                                        dropElementi(
                                          $event,
                                          $any(sottoSottoTemi.controls['impatti'])
                                        )
                                      "
                                    >
                                      @for (
                                        impatti of $any(sottoSottoTemi.controls['impatti'])
                                          .controls;
                                        track $index
                                      ) {
                                        <mat-expansion-panel
                                          (opened)="(false)"
                                          [expanded]="false"
                                          [disabled]="true"
                                          cdkDrag
                                          hideToggle
                                        >
                                          <mat-expansion-panel-header>
                                            <mat-panel-title>
                                              <button
                                                mat-icon-button
                                                title="Sposta"
                                                aria-label="Sposta"
                                              >
                                                <mat-icon class="drag-icon-impatti">
                                                  drag_handle
                                                </mat-icon>
                                              </button>
                                              <div class="cnt-titolo-descrizione-impatto">
                                                <div style="color: black">Impatto</div>
                                                <div class="testo-risposta">
                                                  {{ impatti?.value?.titolo }}
                                                </div>
                                              </div>
                                            </mat-panel-title>
                                            <mat-panel-description
                                              class="impatti-mat-panel-description"
                                            >
                                              <button
                                                mat-icon-button
                                                title="Elimina Sottorisposta"
                                                aria-label="Elimina Sottorisposta"
                                                color="warn"
                                                (click)="
                                                  eliminaElemento(
                                                    sottoSottoTemi.controls['impatti'],
                                                    $index
                                                  )
                                                "
                                              >
                                                <mat-icon>delete</mat-icon>
                                              </button>
                                            </mat-panel-description>
                                          </mat-expansion-panel-header>
                                        </mat-expansion-panel>
                                      }
                                    </div>
                                  </mat-accordion>

                                  <div appFormElement [larghezza]="6" [riempi]="true">
                                    <button
                                      mat-stroked-button
                                      (click)="
                                        apriSelezioneImpatti(sottoSottoTemi.controls['impatti'])
                                      "
                                      class="bottoni-risposte"
                                    >
                                      + Aggiungi Impatti Sotto Tema
                                    </button>
                                  </div>
                                </ngcontainer>
                              </mat-expansion-panel>
                            }
                          </div>
                        </mat-accordion>
                      </ng-container>

                      <div appFormElement [larghezza]="6" [riempi]="true">
                        <button
                          mat-stroked-button
                          (click)="addSottoSottoTema($any(sottoTemi.controls['sottoTemi']))"
                          class="bottoni-risposte"
                        >
                          + Aggiungi Sotto Sotto Tema
                        </button>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                }
              </div>
            </mat-accordion>
          </ng-container>
        </div>

        <div appFormElement [larghezza]="6" [riempi]="true">
          <button mat-stroked-button (click)="addSottoTema()" class="bottoni-risposte">
            + Aggiungi Sotto Tema
          </button>
        </div>
      </form>
    }
  </ng-scrollbar>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
